import fontsList from 'components/Templates/fontsList';

export default function loadSingleFont(fontName, fontWeight, thisWindow) {

  if (!fontName || typeof fontName !== 'string') return;
  const thisFontFame = fontName.split(',')[0];

  let thatWindow = window;

  if (thisWindow && thisWindow.current) thatWindow = thisWindow.current.contentWindow;
  if (thisWindow && typeof thisWindow === 'string') {
    thatWindow = document.querySelector(thisWindow);
    if (thatWindow && thatWindow.contentWindow) {
      thatWindow = thatWindow.contentWindow;
    } else if (thatWindow) {
      thatWindow = thatWindow;
    }
  }

  thatWindow.loadedFonts = thatWindow.loadedFonts ? thatWindow.loadedFonts : [];

  let selectedFont;
  for (let index = 0; index < fontsList.length; index++) {
    const element = fontsList[index];
  
    if (element.name === thisFontFame) {
      selectedFont = element;
      break;
    }
  }

  if (selectedFont && selectedFont.name) {

    if (thatWindow.loadedFonts.includes(selectedFont.name)) return selectedFont.weight[0];
    thatWindow.loadedFonts.push(selectedFont.name);
    const createStyleDom = thatWindow.document.createElement('link');
    createStyleDom.setAttribute('rel', 'stylesheet');
    createStyleDom.setAttribute('href', `https://fonts.bunny.net/css?family=${selectedFont.name.toLocaleLowerCase().replaceAll(' ', '-')+':'+selectedFont.weight}&display=swap`);
    thatWindow.document.head.appendChild(createStyleDom);
    return selectedFont.weight[0];

  }


  
}
